import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { IStateType } from './store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<IStateType> = useSelector